var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 71,
    viewBox: "0 0 73 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82409 63.7829H3.41204C1.68916 63.7829 1 64.56 1 67.28C1 69.456 2.60803 70 3.41204 70C24.7759 70 67.9859 70 69.9155 70C72.3276 70 71.983 68.4457 71.983 66.1143C71.983 63.9383 70.1452 63.6533 69.2264 63.7829H66.8143M5.82409 63.7829V44.7429H17.1951V63.7829M5.82409 63.7829H17.1951M17.1951 63.7829H23.053M23.053 63.7829V38.9143H33.7349V63.7829M23.053 63.7829H33.7349M33.7349 63.7829H39.2481M39.2481 63.7829V32.6971H50.2746V63.7829M39.2481 63.7829H50.2746M50.2746 63.7829H55.7878M55.7878 63.7829V26.8686H66.8143V63.7829M55.7878 63.7829H66.8143M10.6482 31.1429C19.2626 30.2362 38.9035 24.9257 48.5517 10.9371L44.0722 6.66286L59.9228 2V15.9886L55.7878 13.2686C50.1597 21.04 33.2525 35.4949 10.6482 31.1429Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.6026203325106755f1a81cec5b9bb200.svg";
export { ForwardRef as ReactComponent };